// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__IC9Av","vLegacy":"SelectSecondary_vLegacy__1Iv-q","error":"SelectSecondary_error__20WSq","disabled":"SelectSecondary_disabled__EcaHa"};